import { createContext, useContext } from "react";

type DrawerContextType = {
  onClose: () => void;
};

const DrawerContext = createContext<DrawerContextType>({ onClose: () => {} });

export const DrawerContextProvider = DrawerContext.Provider;
export const useDrawerContext = (): DrawerContextType =>
  useContext(DrawerContext);
